import { DTOgetOrderDetailedData, ORDER_STATUS } from 'types/orders';
import { AdditionalTaxComponent } from 'views/orders/OrderDetailInternalCard/Components/Tab1General/Components';
import { CURRENCY_CODE_BY_COUNTRY_NAME } from 'constants/constants';
import { COUNTRY_NAME } from 'types/global';

import './BillingAdditionalTaxSection.scss';

interface IBillingAdditionalTaxSection {
  orderData?: DTOgetOrderDetailedData;
  refreshData?: () => void;
}

const COUNTRIES_ALLOWED_TO_SHOW_ADDITIONAL_TAX = [COUNTRY_NAME.Argentina, COUNTRY_NAME.Brasil];

export const BillingAdditionalTaxSection = ({ orderData, refreshData }: IBillingAdditionalTaxSection) => {
  const id = orderData?.orderId;

  const countryBilling = orderData?.billingData?.countryBilling! as COUNTRY_NAME;

  const billingCountryIsArgentina = COUNTRIES_ALLOWED_TO_SHOW_ADDITIONAL_TAX.includes(countryBilling);
  const showAdditionalTaxComponent =
    billingCountryIsArgentina && Boolean(orderData?.orderId) && Boolean(orderData?.generalData?.paymentData);

  const disabled = orderData?.statusName === ORDER_STATUS.CANCELLED;

  if (!showAdditionalTaxComponent) return <></>;

  return (
    <div className="billingAdditionalTaxSection">
      <AdditionalTaxComponent
        showComponent={showAdditionalTaxComponent}
        currencyCode={CURRENCY_CODE_BY_COUNTRY_NAME[countryBilling]}
        orderId={Number(id)}
        paymentData={orderData?.generalData?.paymentData}
        updateWithLoaders={refreshData}
        disabledComponent={disabled}
      />
    </div>
  );
};
